import enviro from 'enviro';

const logShown = {} as Record<string, unknown>;

const shouldLog = (key: null | string): boolean => {
  return !enviro.deployed() && (key == null || !logShown[key]);
};

const markAsShown = (key: null | undefined | string) => {
  if (key) {
    logShown[key] = true;
  }
};

export const warn = ({
  message = '',
  key,
  url,
}: {
  message?: string;
  key: null | string;
  url?: string;
}) => {
  if (url) {
    message += `\nFor details, see: ${url}`;
  }

  if (shouldLog(key)) {
    console.warn(message);
    markAsShown(key);
  }
};

export default {
  warn,
};
